import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, theme } from '@robinpowered/ui-kit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faClockRotateLeft, } from '@awesome.me/kit-cf858715fd/icons/classic/solid';
import { useTranslation } from 'react-i18next';
/**
 * Entry-point button rendered in the composer that opens the
 * {@link TimeSuggestions} drawer.
 */
export var SuggestedTimesButton = function (_a) {
    var onClick = _a.onClick;
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    return (_jsx(Button, { block: true, onClick: onClick, style: { color: token.colorTextPlaceholder }, children: _jsxs(Flex, { align: "center", gap: 8, style: { width: '100%' }, children: [_jsx(FontAwesomeIcon, { icon: faClockRotateLeft }), _jsx("span", { style: { flex: 1, textAlign: 'left' }, children: t('time_suggestions.title') }), _jsx(FontAwesomeIcon, { icon: faAngleRight, color: token.colorTextTertiary })] }) }));
};
